module.exports = __webpack_public_path__ + "img/04-revisit-our-web-discussions.c7eef7b4.jpg";